export const paymenthistorystuApi = {

    heading:[
        {
            head:"Student Name"
        },
        {
            head:"Bill No."
        },
        {
            head:"Class"
        },
        {
            head:"Month"
        },
        {
            head:"Payment Date"
        },
        {
            head:"Payment Type"
        },
        {
            head:"Paid Amount"
        },
        {
            head:"Remark"
        }
    ],
    data:[
        {

        },
        {

        },
        {

        },
        {

        },
        {

        },
    ]
}